import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'corner-down-right', 'IconCornerDownRight', [["path",{"d":"M6 6v6a3 3 0 0 0 3 3h10l-4 -4m0 8l4 -4","key":"svg-0"}]]);